export default "__VITE_ASSET__CU6_WAs6__"